import {ChangeDetectionStrategy, Component, input} from "@angular/core"

@Component({
    selector: "cm-comment-boxes",
    templateUrl: "./comment-boxes.component.html",
    styleUrls: ["./comment-boxes.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentBoxesComponent {
    readonly $entity = input<{
        taskInfos: {inProgress: number; waitingForFeedback: number; completed: number; archived: number}
    }>(undefined, {alias: "entity"})
}
